import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { t } from '../i18n.js';
import { api } from '../state/auth.js';
import DataTable from '../components/shared/DataTable.jsx';
import Filters, { MultiFilterSelect } from '../components/shared/Filters.jsx';
import StatusBadge from '../components/shared/StatusBadge.jsx';
import { parseServerDate } from '../utils/dates.js';

const ACTION_TYPES = ['create', 'update', 'delete', 'login', 'logout'];
const OBJECT_TYPES = ['club', 'process', 'task', 'template', 'user', 'document'];

export default function AuditView() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionType, setActionType] = useState([]);
  const [objectType, setObjectType] = useState([]);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (actionType.length > 0) params.set('action', actionType.join(','));
    if (objectType.length > 0) params.set('object_type', objectType.join(','));
    const qs = params.toString();
    api(`/api/audit${qs ? `?${qs}` : ''}`)
      .then(setLogs)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [actionType, objectType]);

  const columns = [
    {
      key: 'created_at',
      label: t('audit.date'),
      render: row => parseServerDate(row.created_at).toLocaleString()
    },
    {
      key: 'user_name',
      label: t('audit.user')
    },
    {
      key: 'action',
      label: t('audit.action'),
      render: row => (
        <span class={`badge badge-${row.action}`}>
          {t(`audit.actions.${row.action}`)}
        </span>
      )
    },
    {
      key: 'object_type',
      label: t('audit.objectType'),
      render: row => row.object_type
    },
    {
      key: 'object_id',
      label: t('audit.objectId')
    }
  ];

  return (
    <div>
      <div class="page-header">
        <h1 class="page-title">{t('audit.title')}</h1>
      </div>

      <Filters>
        <MultiFilterSelect
          label={t('audit.actionType')}
          values={actionType}
          options={ACTION_TYPES.map(a => ({ value: a, label: t(`audit.actions.${a}`) }))}
          onChange={setActionType}
        />
        <MultiFilterSelect
          label={t('audit.objectType')}
          values={objectType}
          options={OBJECT_TYPES.map(o => ({ value: o, label: o }))}
          onChange={setObjectType}
        />
      </Filters>

      {loading ? (
        <div class="text-center text-muted" style="padding:60px">{t('common.loading')}</div>
      ) : (
        <DataTable columns={columns} data={logs} />
      )}
    </div>
  );
}
